import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=414afcf5&"
import script from "./turnstile.vue?vue&type=script&lang=js&"
export * from "./turnstile.vue?vue&type=script&lang=js&"
import style0 from "./turnstile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414afcf5')) {
      api.createRecord('414afcf5', component.options)
    } else {
      api.reload('414afcf5', component.options)
    }
    module.hot.accept("./turnstile.vue?vue&type=template&id=414afcf5&", function () {
      api.rerender('414afcf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/turnstile.vue"
export default component.exports